import { useEffect, useContext, useRef } from "react";
import { useBlocker } from "react-router-dom";
import { Context } from "./context";

export function usePrompt(when = true) {
  const showPrompt = useContext(Context);

  const blocker = useBlocker(when);

  const showPromptRef = useRef(showPrompt);
  showPromptRef.current = showPrompt;

  const blockerRef = useRef(blocker);
  blockerRef.current = blocker;

  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [when]);

  useEffect(() => {
    if (blocker.state !== "blocked") {
      return;
    }

    let cancelled = false;

    showPromptRef.current()
      .then(() => {
        if (!cancelled) {
          blockerRef.current.proceed();
        }
      })
      .catch(() => {
        if (!cancelled) {
          blockerRef.current.reset();
        }
      });

    return () => {
      cancelled = true;
    };
  }, [blocker.state]);
}
